import { useState, useEffect } from "react";
import { Steps,Form, Input, Select, Switch , Alert} from "antd";
import Button from './Button.jsx'
import { getNames } from 'country-list';
import Header from "@components/Header.jsx";
import { db } from '../firebaseConfig.js' // update path as needed
import { collection, addDoc, serverTimestamp, doc, updateDoc } from "firebase/firestore";
import {useAuth} from "@/utils/auth.jsx";
import {useLocation, useNavigate} from "react-router-dom";


const { Step } = Steps;
const {TextArea} = Input;

const CreateApp = () => {
    const [current, setCurrent] = useState(0);
    const [form] = Form.useForm();
    const countryNames = getNames();
    const [rating, setRating] = useState(false);
    const [likes, setLikes] = useState(false);
    const ratings = [1,2,3,4,5];
    const [reviews, setReviews] = useState(false);
    const options = [
        "1 day",
        "2, 3 day",
        "2, 3, 8, 16 day (recommended)",
        "2, 3, 8, 16, 23 day"
    ];
    const {user} = useAuth();
    const location = useLocation();
    const { app } = location.state || {};
    const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

    useEffect(() => {
        if (app) {
            form.setFieldsValue({
                appName: app.appName,
                appUrl: app.appUrl,
                orderId: app.orderId,
                geotargeting: app.geotargeting,
                rating: app.rating,
                likes: app.likes,
                reviews: app.reviews,
                search: app.search,
                status: app.status,
                stats: app.stats,
            });

            setRating(!!app.rating);
            setLikes(!!app.likes);
            setReviews(!!app.reviews);
        }
    }, [app, form]);



    const steps = [
        {
            title: "Details",
            description: "URL of app",
            content: (
                <>
                    <Form.Item
                        label="Application Name"
                        name="appName"
                        rules={[{ required: true, message: "Please enter app name" }]}
                    >
                        <Input.TextArea rows={4} />
                    </Form.Item>
                    <Form.Item
                        label="Package Name / URL"
                        name="appUrl"
                        rules={[{ required: true, message: "Please enter app URL" }]}
                    >
                        <Input />
                    </Form.Item>
                </>
            ),
        },
        {
            title: "Order",
            description: "Order Details",
            content: (
                <>
                    <Form.Item
                        label="Order ID"
                        name="orderId"
                        rules={[{ required: true, message: "Please enter order ID" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="geotargeting"
                        label="Geo Targeting"
                        rules={[{ required: true, message: "Select a country" }]}
                    >
                        <Select showSearch placeholder="Select a country">
                            {countryNames.map((country) => (
                                <Select.Option key={country} value={country}>
                                    {country}
                                </Select.Option>
                            ))}
                        </Select>

                    </Form.Item>
                </>

            ),
        },

        {
            title: "Reviews, ratings, likes",
            description: "Rating adjustment",
            content: (
                <>
                <Form.Item
                    required
                >
                    <Switch checkedChildren="Give a rating" unCheckedChildren="Give a rating" checked={rating} onChange={setRating} />

                    {rating && (
                        <Form.Item
                            name="rating"
                            rules={[{ required: true, message: "Please enter a rating" }]}
                            noStyle
                        >

                            <Select style={{ marginTop: "10px" }} showSearch placeholder="Choose a value">
                                {ratings.map((rating) => (
                                    <Select.Option key={rating} value={rating}   >
                                        {rating}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    )}
                </Form.Item>

                    <Form.Item
                        required
                    >
                        <Switch checkedChildren="With likes" unCheckedChildren="With likes" checked={likes} onChange={setLikes} />

                        {likes && (
                            <Form.Item
                                name="likes"
                                rules={[{ required: true, message: "Please enter a likes" }]}
                                noStyle
                            >

                                <Select style={{ marginTop: "10px" }} showSearch placeholder="Choose a value">
                                    {ratings.map((rating) => (
                                        <Select.Option key={rating} value={rating}   >
                                            {rating}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        )}
                    </Form.Item>

                    <Form.Item
                        required
                    >
                        <Switch checkedChildren="With reviews" unCheckedChildren="With reviews" checked={reviews} onChange={setReviews} />

                        {reviews && (
                            <Form.Item
                                name="reviews"
                                rules={[{ required: true, message: "Please enter a review" }]}
                                noStyle
                            >
                                <TextArea style={{ marginTop: "10px" }}  rows={4}/>

                            </Form.Item>
                        )}
                    </Form.Item>

                </>
            ),
        },
        {
            title: "Special tasks",
            description: "Search query, add. launches, tasks",
            content: (
                <Form.Item
                    label="Prohibition of deletion with restart"
                    name="search"
                    rules={[{ required: true, message: "Select an option" }]}
                >

                    <Select style={{ marginTop: "10px" }} showSearch placeholder="Select an option">
                        {options.map((option) => (
                            <Select.Option key={option} value={option}   >
                                {option}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: "Done!",
            description: "Submitting for moderation",
            content: <p>You're all set! Click Submit to finish.</p>,
        },
    ];

    const stepFieldNames = [
        ["appName", "appUrl"],
        ["orderId", "geotargeting"],
        ["rating", "likes", "reviews"],
        ["search"]
    ];

    const next = async () => {
        const fieldsToValidate = stepFieldNames[current];

        try {
            await form.validateFields(fieldsToValidate);
            setCurrent((prev) => prev + 1);
        } catch (error) {
            // Не прошли валидацию — не двигаемся дальше
        }
    };

    const prev = () => setCurrent((prev) => prev - 1);
    const navigate = useNavigate();

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();

            const dataToSave = {
                ...values,
                rating: rating ? values.rating : null,
                likes: likes ? values.likes : null,
                reviews: reviews ? values.reviews : null,
                ownerId: user.uid,
                status: 'moderation',
                ownerEmail: user.email,
                stats: {},
                available: true,

            };

            if (app && app.id) {
                // Обновляем документ
                const docRef = doc(db, "apps", app.id);
                await updateDoc(docRef, dataToSave);
            } else {
                // Создаем новый документ с отметкой времени
                dataToSave.createdAt = serverTimestamp();
                await addDoc(collection(db, "apps"), dataToSave);
            }

            setSuccess(true);
           
            form.resetFields();
            setCurrent(0);
            setRating(false);
            setLikes(false);
            setReviews(false);
            navigate("/app");

        } catch (error) {
            console.error("❌ Error submitting form:", error);
           setError(true);
        }
    };



    return (
        <div className="createApp">
            {success && (
                <Alert
                    message="Form submitted!"
                    type="success"
                    showIcon
                    closable
                    onClose={() => setSuccess(false)}
                />
            )}

            {error && (
                <Alert
                    message="Someting went wrong!"
                    type="error"
                    showIcon
                    closable
                    onClose={() => setError(false)}
                />
            )}

            <div className="wrapper">
                <Header title={`Create App`} />
                <div className="page page--createApp">
                    <Steps current={current} direction="vertical" className="stepper">
                        {steps.map((item, index) => (
                            <Step key={index} title={item.title} description={item.description} />
                        ))}
                    </Steps>

                    <Form
                        form={form}
                        layout="vertical"
                        style={{ marginTop: "24px" }}
                        onFinish={handleSubmit}
                        initialValues={{
                            rating: null,
                            likes: null,
                            reviews: null,
                        }}
                    >
                        {steps.map((item, index) => (
                            <div key={index} style={{ display: current === index ? "block" : "none" }}>
                                {item.content}
                            </div>
                        ))}



                        <div className={`page-buttons`}>
                            {current > 0 && (
                                <Button title={'Previous'} onClick={prev}/>
                            )}
                            {current < steps.length - 1 && (
                                <Button title={'Next'} onClick={next}/>
                            )}
                            {current === steps.length - 1 && (
                                <Button htmlType="submit" title="Submit" />

                            )}
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default CreateApp;

